import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenWidth, getScreenIsReady, getIsMobileScreenWidth } from 'selectors/screen'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { SAArtwork } from 'types/Artwork'
import { getUserID, isSessionSet } from 'selectors/user/session'
import {
  getHitsResults,
  getSelectedPromoCode,
  getSelectedPromoDiscount,
  getSelectedPromoHash,
  getSortIndice,
} from '../selectors/algolia'
import { getIsUsersArtworksAccount, getIsBlackout } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  artworks: getHitsResults,
  isReady: getScreenIsReady,
  isSet: isSessionSet,
  algoliaIndice: getSortIndice,
  algoliaUserToken: getAlgoliaUserToken,
  userID: getUserID,
  isUsersArtworksAccount: getIsUsersArtworksAccount,
  promoCode: getSelectedPromoCode,
  discount: getSelectedPromoDiscount,
  pdpHash: getSelectedPromoHash,
  isBlackout: getIsBlackout,
})

export type ConnectorProps = {
  artworks: ReadonlyArray<SAArtwork>
  isReady: boolean
  isSet: boolean
  isUsersArtworksAccount: boolean
  algoliaIndice: string
  algoliaUserToken: string
  userID: number
  promoCode: string
  discount: number
  pdpHash: string
  isBlackout: boolean
}
export default connect(mapStateToProps)
